import React, { useMemo, useCallback } from 'react';
import {
  TabContent,
  EmptyState,
  AddMappingButton,
  XPathMappingTable,
  XPathTableHeader,
  XPathTableBody,
  MonacoOverflowGlobalStyle,
} from './styles';
import XPathMappingRow from './XPathMappingRow';
import { BUSINESS_CONTRACTS as trans } from './translationValues';
import { buildPathTree } from './jxpathSchema';
import { createLogicMappingEntryId } from '../../utils/contractHelpers';

const XPathMappingsEditor = ({
  entries: safeEntries,
  onEntriesChange,
  hasSchema,
  dataJson,
  t,
  globalVariables = [],
  updateGlobalVariables,
  relationships = [],
}) => {

  const handleAddMapping = useCallback(() => {
    onEntriesChange((prev) => {
      const arr = Array.isArray(prev) ? prev : [];
      return [
        ...arr,
        {
          id: `logic-row-${createLogicMappingEntryId()}-${Date.now()}`,
          xpath: '',
          variable: '',
        },
      ];
    });
  }, [onEntriesChange]);

  const handleXPathChange = useCallback((index, xpath) => {
    onEntriesChange((prev) => {
      const arr = Array.isArray(prev) ? prev : [];
      return arr.map((e, i) => (i === index ? { ...e, xpath } : e));
    });
  }, [onEntriesChange]);

  const handleVariableChange = useCallback((index, variable) => {
    onEntriesChange((prev) => {
      const arr = Array.isArray(prev) ? prev : [];
      return arr.map((e, i) => (i === index ? { ...e, variable } : e));
    });
  }, [onEntriesChange]);

  const handleDelete = useCallback((index) => {
    onEntriesChange((prev) => {
      const arr = Array.isArray(prev) ? prev : [];
      return arr.filter((_, i) => i !== index);
    });
  }, [onEntriesChange]);

  const pathTree = useMemo(() => buildPathTree(dataJson ?? {}), [dataJson]);

  if (!hasSchema) {
    return (
      <>
        <MonacoOverflowGlobalStyle />
        <TabContent>
          <EmptyState>
            <h3>{t(trans.IMPORT_YOUR_DATA_FIRST.key, trans.IMPORT_YOUR_DATA_FIRST.value)}</h3>
            <p>{t(trans.IMPORT_DATA_MESSAGE.key, trans.IMPORT_DATA_MESSAGE.value)}</p>
          </EmptyState>
        </TabContent>
      </>
    );
  }

  return (
    <>
      <MonacoOverflowGlobalStyle />
      <TabContent style={{ paddingBottom: '20px' }}>
      <AddMappingButton onClick={handleAddMapping} icon="plus">
        {t(trans.ADD_MAPPING.key, trans.ADD_MAPPING.value)}
      </AddMappingButton>
      {safeEntries.length > 0 ? (
        <XPathMappingTable>
          <XPathTableHeader>
            <div>{t(trans.MAPS_TO_VARIABLE.key, trans.MAPS_TO_VARIABLE.value)}</div>
            <div>{t(trans.XPATH_EXPRESSION.key, trans.XPATH_EXPRESSION.value)}</div>
            <div></div> {/* For delete icon */}
          </XPathTableHeader>
          <XPathTableBody>
            {safeEntries.map((entry, index) => (
              <XPathMappingRow
                key={entry.id}
                index={index}
                entry={entry}
                pathTree={pathTree}
                onXPathChange={handleXPathChange}
                onVariableChange={handleVariableChange}
                onDelete={handleDelete}
                t={t}
                globalVariables={globalVariables}
                updateGlobalVariables={updateGlobalVariables}
                relationships={relationships}
              />
            ))}
          </XPathTableBody>
        </XPathMappingTable>
      ) : (
        <EmptyState>
          <p>No custom logic mappings yet. Click &quot;Add Mapping&quot; to create one.</p>
        </EmptyState>
      )}
    </TabContent>
    </>
  );
};

export default XPathMappingsEditor;
